import { render, staticRenderFns } from "./TypeSolicitationTypeDocumentList.vue?vue&type=template&id=09510fd1&scoped=true"
import script from "./TypeSolicitationTypeDocumentList.vue?vue&type=script&lang=js"
export * from "./TypeSolicitationTypeDocumentList.vue?vue&type=script&lang=js"
import style0 from "./TypeSolicitationTypeDocumentList.vue?vue&type=style&index=0&id=09510fd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09510fd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
